/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyBeneficiary = {

	deleteBeneficiary (context, contestId, beneficiaryId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-beneficiary/beneficiary"
			+ "?contestId=" + contestId
			+ "&beneficiaryId=" + beneficiaryId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllBeneficiaries (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-beneficiary/all-beneficiaries"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, beneficiaryId, name, onSuccess, onError, options) {
		Api.put(context,
			"/agency-beneficiary"
			+ "?beneficiaryId=" + beneficiaryId
			+ "&name=" + name
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putBeneficiary (context, contestId, name, onSuccess, onError, options) {
		Api.put(context,
			"/agency-beneficiary/beneficiary"
			+ "?contestId=" + contestId
			+ "&name=" + name
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putDownwards (context, contestId, beneficiaryId, onSuccess, onError, options) {
		Api.put(context,
			"/agency-beneficiary/downwards"
			+ "?contestId=" + contestId
			+ "&beneficiaryId=" + beneficiaryId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUpwards (context, contestId, beneficiaryId, onSuccess, onError, options) {
		Api.put(context,
			"/agency-beneficiary/upwards"
			+ "?contestId=" + contestId
			+ "&beneficiaryId=" + beneficiaryId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
